import React, { useEffect, useState } from "react";
import MainCategory from '../../components/Categories/MainCategory';
import { create, remove, search, update } from '../../services/category';

export default function Category({ setTitle }) {
  useEffect(() => { setTitle('HLP - Categories'); }, [setTitle]);

  const [optionSearch, setOptionSearch] = useState({
    name: '',
  });
  const [data, setData] = useState();

  // Get data
  useEffect(() => {
    searchData(optionSearch)
  }, [optionSearch]);

  const searchData = (option) => {
    search(option).then((res) => setData(res.data)).catch((err) => console.log(err.message));
  }

  const handlePost = (option, action) => {
    if (option)
    {
      switch (action) {
        case 0:
          return create(option);
        case 1:
          return update(option);
        case 2:
          return remove(option);
        default:
          break;
      }
    }
  }

  return (
    <div className='min-h-screen p-4'>
      <MainCategory data={data} optionSearch={optionSearch} searchData={searchData} handlePost={handlePost} setOptionSearch={setOptionSearch} setData={setData} />
    </div>
  );
}
